import styled from '@emotion/styled'
import { colors } from '../../shared/ui/colors'

export const PageContainer = styled.div`
  padding: 32px;
  min-height: 100vh;

  @media (max-width: 768px) {
  }
`

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 16px;
  }
`

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`

export const HeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
`

export const PageTitle = styled.h1`
  font-size: 1.5rem;
  color: ${colors.gray900};
  font-weight: 500;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`

export const PageSubtitle = styled.p`
  font-size: 1rem;
  color: ${colors.gray600};
  margin: 0;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`

export const HeaderActions = styled.div`
  display: flex;
  gap: 12px;

  @media (max-width: 900px) {
    width: 100%;
    flex-direction: column;
  }
`

export const ContentContainer = styled.div`
  background-color: ${colors.white};
  border-radius: 12px;
  padding: 16px;

  @media (max-width: 768px) {
  }
`

export const CenteredLoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 64px);
  padding: 60px 20px;
  gap: 16px;
`
